import { useCallback } from 'react';
import { cn } from '@/utils/сn';
import { Controller, useFormContext } from 'react-hook-form';
import type { MultiValue } from 'react-select';
import { getAirportLabel } from '@/app/(main)/client-detail/edit-main/utils/getAirportLabel';
import type { OptionType } from '@/app/components/form/MultiSelect/types';
import { MultiSelectWitInfiniteScroll } from '@/app/components/form/Selector/MultiSelectWitInfiniteScroll';
import type { GetPreferredAirportData } from '@/types/clientDetailsApiTypes';
import FlyIcon from '/public/icons/fly-start.svg';
interface AirportsListProps {
  onUpdateFormData?: (fieldName: string, fieldValue: unknown) => void;
  label?: string;
  title?: string;
  wrapperClassName?: string;
  fieldPrefix?: string;
}

export const AirportsList = ({ onUpdateFormData, label, title, wrapperClassName, fieldPrefix = 'primary_passenger' }: AirportsListProps) => {
  const {
    setValue,
    watch,
    control,
    formState: { errors },
  } = useFormContext();
  const selectedAirports = watch(`${fieldPrefix}.selected_airports`) ?? [];
  const NAME = `${fieldPrefix}.client.preferred_airport_ids`;

  const handleSelectAirport = (options: MultiValue<OptionType>) => {
    setValue(
      NAME,
      options.map((option) => option.value)
    );
    setValue(`${fieldPrefix}.selected_airports`, options);
    onUpdateFormData?.(
      NAME,
      options.map((option) => option.value)
    );
  };

  const mapAirportOptions = useCallback((options: GetPreferredAirportData[]) => {
    return options.map((option) => ({
      value: option.id,
      label: getAirportLabel({ id: option.id, code: option.iata_code, city: option.city, country: option.country }),
      city: option.city,
      country: option.country,
      code: option.iata_code,
      multiValueLabel: option.iata_code,
    }));
  }, []);

  return (
    <div className={cn('mx-5 mt-2 pl-1', wrapperClassName)}>
      {title && <h5 className="pb-4 text-black">{title}</h5>}
      <Controller
        name={NAME}
        control={control}
        render={() => (
          <MultiSelectWitInfiniteScroll<GetPreferredAirportData>
            queryKey={['preferred_airports']}
            value={selectedAirports}
            optionType='check-box-right'
            label={label}
            startIcon={<FlyIcon />}
            url="/api/public/airports/global-search"
            mapOptions={mapAirportOptions}
            onChange={(values) => handleSelectAirport(values)}
            placeholder="Select airports"
            errors={errors}
            isClearable={false}
            name={NAME}
          />
        )}
      />
    </div>
  );
};
